export const ENABLE_CANARY_VERSION =
  "shared/CanaryVersions/ENABLE_CANARY_VERSION";

const PNP_BASE_OFFERS = "pnp-base-offers";

const PNP_UPGRADED_OFFERS = "pnp-upgraded-offers";

export const TYPES_OF_CANARY_VERSIONS = {
  canary1: "canary1",
  canary2: "canary2",
  canary3: "canary3",
  wccoffers: "wccoffers",
  strikethrough: "strikethrough",
  [PNP_BASE_OFFERS]: PNP_BASE_OFFERS,
  [PNP_UPGRADED_OFFERS]: PNP_UPGRADED_OFFERS,
};
